import Component from 'components/pages/ReferralInvites/ReferralInvites';
import { buildPage } from 'utils/pageHelper';
export default buildPage(Component, {
  requiresAuthentication: true,
  metaData: {
    title: 'Refer',
    description: 'Refer a friend to Qmee',
  },
});
